__turbopack_context__.v({
  "accent": "_9K_zcW_accent",
  "bookCover": "_9K_zcW_bookCover",
  "bookLink": "_9K_zcW_bookLink",
  "carouselCard": "_9K_zcW_carouselCard",
  "carouselTrack": "_9K_zcW_carouselTrack",
  "carouselWrap": "_9K_zcW_carouselWrap",
  "closing": "_9K_zcW_closing",
  "closingBanner": "_9K_zcW_closingBanner",
  "coralCta": "_9K_zcW_coralCta",
  "ctaRow": "_9K_zcW_ctaRow",
  "deals": "_9K_zcW_deals",
  "dealsSub": "_9K_zcW_dealsSub",
  "dot": "_9K_zcW_dot",
  "dotActive": "_9K_zcW_dotActive",
  "dots": "_9K_zcW_dots",
  "emailInput": "_9K_zcW_emailInput",
  "emailRow": "_9K_zcW_emailRow",
  "feature": "_9K_zcW_feature",
  "featureVisual": "_9K_zcW_featureVisual",
  "features": "_9K_zcW_features",
  "googleWrap": "_9K_zcW_googleWrap",
  "header": "_9K_zcW_header",
  "headerRow": "_9K_zcW_headerRow",
  "headerScrolled": "_9K_zcW_headerScrolled",
  "headerSolid": "_9K_zcW_headerSolid",
  "headerSticky": "_9K_zcW_headerSticky",
  "hero": "_9K_zcW_hero",
  "heroBanner": "_9K_zcW_heroBanner",
  "heroCard": "_9K_zcW_heroCard",
  "loginBtn": "_9K_zcW_loginBtn",
  "logoFallback": "_9K_zcW_logoFallback",
  "logoImage": "_9K_zcW_logoImage",
  "logoWrap": "_9K_zcW_logoWrap",
  "orDivider": "_9K_zcW_orDivider",
  "page": "_9K_zcW_page",
  "pointImage": "_9K_zcW_pointImage",
  "priceBadge": "_9K_zcW_priceBadge",
  "retailerLogos": "_9K_zcW_retailerLogos",
  "signupError": "_9K_zcW_signupError",
  "signupForm": "_9K_zcW_signupForm",
  "signupForm_closing": "_9K_zcW_signupForm_closing",
  "signupForm_modal": "_9K_zcW_signupForm_modal",
  "signupForm_simpleClosing": "_9K_zcW_signupForm_simpleClosing",
  "signupForm_simpleHero": "_9K_zcW_signupForm_simpleHero",
  "signupForm_sticky": "_9K_zcW_signupForm_sticky",
  "signupModalHeadline": "_9K_zcW_signupModalHeadline",
  "signupModalShell": "_9K_zcW_signupModalShell",
  "srOnly": "_9K_zcW_srOnly",
  "starImage": "_9K_zcW_starImage",
  "stars": "_9K_zcW_stars",
  "startReadingBtn": "_9K_zcW_startReadingBtn",
  "stickyDesktopForm": "_9K_zcW_stickyDesktopForm",
  "stickyHeadline": "_9K_zcW_stickyHeadline",
  "stickyMobileCta": "_9K_zcW_stickyMobileCta",
  "stickySignup": "_9K_zcW_stickySignup",
  "stickySignupInner": "_9K_zcW_stickySignupInner",
  "stickySignupOpen": "_9K_zcW_stickySignupOpen",
  "testimonialCard": "_9K_zcW_testimonialCard",
  "testimonials": "_9K_zcW_testimonials",
  "testimonialsDesktop": "_9K_zcW_testimonialsDesktop",
  "testimonialsMobile": "_9K_zcW_testimonialsMobile",
});
